import React from "react";
import { ToastContainer } from "react-toastify";
import ViewEmailSubscribe from "../../components/Requests/EmailSubscribe/ViewEmailSubscribe";

export const ViewEmailSubscribePage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ViewEmailSubscribe />
        </div>
      </div>
    </div>
  );
};
